module.exports = __webpack_public_path__ + "static/media/jkpg.dbf69a6c.jpg";